/**
 * 媒体资源 URL：固定静态图走本地，业务动态图仍走 CDN 前缀
 */
export const CDN_BASE = 'https://www.wordkillstu.com.cn'
export const API_BASE = CDN_BASE + '/backend'

/** 已下载到本地的固定静态资源（避免远程变动） */
export const LOCAL_STATIC = {
  weixing: require('@/assets/remote/weixing.jpg')
}

/**
 * 解析后端返回的相对路径（如 /profile/xxx.jpg、/datainfo/xxx.jpg）
 * 头像与教材图优先走站点根路径（nginx /profile alias）
 */
export function resolveMediaUrl (path) {
  if (!path) return ''
  let raw = String(path).trim().replace(/\\/g, '/')
  if (!raw) return ''
  if (/^https?:\/\//i.test(raw)) return raw
  const p = raw.startsWith('/') ? raw : '/' + raw
  // H5 本地静态资源（卡通模板 SVG 等）
  if (p.startsWith('/static/')) return p
  if (p.startsWith('/backend/')) {
    return CDN_BASE + p
  }
  return CDN_BASE + p
}

/** 头像加载失败时切换备用地址（nginx 根路径 ↔ backend 静态映射） */
export function alternateMediaUrl (currentSrc) {
  if (!currentSrc) return ''
  if (currentSrc.indexOf(API_BASE + '/profile/') === 0) {
    return currentSrc.replace(API_BASE + '/profile/', CDN_BASE + '/profile/')
  }
  if (currentSrc.indexOf(CDN_BASE + '/profile/') === 0) {
    return currentSrc.replace(CDN_BASE + '/profile/', API_BASE + '/profile/')
  }
  return ''
}

export default { CDN_BASE, API_BASE, LOCAL_STATIC, resolveMediaUrl, alternateMediaUrl }



// WEBPACK FOOTER //
// ./src/utils/mediaUrl.js